import { useDispatch } from "react-redux"
import { useNavigate } from "react-router-dom";
import { FormsSignIn } from "../form/formSignIn";
import { setUser } from "../../store/reducer/userReducer";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
const Login = () => {
    const auth = getAuth();
    const history = useNavigate();
    const dispatch = useDispatch();
    const handleLogin = async (data) => {
        signInWithEmailAndPassword(auth, data.email, data.password)
            .then(({ user }) => {
                dispatch(setUser({
                    email: user.email,
                    id: user.uid,
                    token: user.accessToken,
                    username: user.displayName,
                }));
                history('/')
            })
            .catch((error) => {
                console.log(error)
            });
    }
    return (
        <>
            <FormsSignIn
                title="Войти"
                handleLogin={handleLogin}
            />
        </>
    )
}
export { Login }